import { useSyncExternalStore } from "react"
import { getShellNavPendingHref, subscribeShellNavPending } from "@/lib/shell-nav-pending"
import { shellNavUrl } from "@/lib/task-board"

/**
 * Server URL until a menu click, then the clicked href as the menu sees it.
 * Task deep links count as their board. Subscribing does not rerender the page.
 */
export function useShellNavUrl(serverUrl: string): string {
  const pending = useSyncExternalStore(subscribeShellNavPending, getShellNavPendingHref, getShellNavPendingHref)
  return pending == null ? serverUrl : shellNavUrl(pending)
}
